
export default {
  // api:  'https://yuhou.aiteyixia.cn/' http://192.168.20.125:8087/  http://test.aiteyixia.cn/  http://192.168.20.190:8087/ http://192.168.1.239:8087/
  api: process.env.NODE_ENV === 'development' ? "http://192.168.1.237:8087/" : 'https://yuhou.aiteyixia.cn/'

}


// WEBPACK FOOTER //
// ./src/serve.js